/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import { rebrandText } from 'shared/helpers/brandingPostTranslation';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces upstream branding ("Chatwoot" and chatwoot.com links) in text
   * with the installation name from global config (falls back to Wasapi)
   * @param {string} text - The text to process
   * @returns {string} - Rebranded text
   */
  const replaceInstallationName = text =>
    rebrandText(text, globalConfig.value?.installationName);

  return {
    replaceInstallationName,
  };
}
